<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="La formation par Unité" />
        <ParcoursUnite/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import FooterComp from '../Layouts/FooterComp'
import ParcoursUnite from './ParcoursUnite.vue';


export default {
    name: 'SecretariatPage',
    components: {
        NavBar,
        PageTitle,
        ParcoursUnite,
        FooterComp,
    }
}
</script>